__turbopack_context__.v({
  "className": "montserrat_394881a-module__E9N5LG__className",
  "variable": "montserrat_394881a-module__E9N5LG__variable",
});
